import * as React from "react";
import * as Pages from "@/components/Pages";
import * as PageOptions from "@/components/PaperContainer/PageOptions";

import { useLoadedData } from "./loader";
import { useMe } from "@/contexts/CurrentCompanyContext";
import { compareIds } from "@/routes/paths";
import { useNavigate } from "react-router";
import { Forms, IconEdit, IconTrash, Modal, showSuccessToast } from "turboui";
import { useBoolState } from "@/hooks/useBoolState";
import { useDeleteGoalProgressUpdate } from "@/models/goalCheckIns";
import { usePaths } from "@/routes/paths";

export function Options() {
  const { update, goal } = useLoadedData();
  const [showDiscardModal, toggleDiscardModal] = useBoolState(false);

  const mode = Pages.usePageMode();
  const setPageMode = Pages.useSetPageMode();
  const me = useMe()!;

  const isUnpublished = update.state === "draft" || update.state === "scheduled";
  const isAuthor = compareIds(me.id, update.author?.id);
  const isEditVisible = isAuthor && mode === "view";
  const isDiscardVisible = isUnpublished && mode === "view";

  if (!isEditVisible && !isDiscardVisible) return null;

  return (
    <>
      <PageOptions.Root testId="check-in-options">
        {isEditVisible && (
          <PageOptions.Action
            icon={IconEdit}
            title={"Edit"}
            onClick={() => setPageMode("edit")}
            testId="edit-check-in"
            keepOutsideOnBigScreen
          />
        )}
        {isDiscardVisible && (
          <PageOptions.Action
            icon={IconTrash}
            title="Отменить черновик"
            onClick={toggleDiscardModal}
            testId="delete-check-in"
          />
        )}
      </PageOptions.Root>
      <DiscardDraftModal
        isOpen={showDiscardModal}
        toggleModal={toggleDiscardModal}
        updateId={update.id!}
        goalId={goal.id!}
      />
    </>
  );
}

function DiscardDraftModal({
  isOpen,
  toggleModal,
  updateId,
  goalId,
}: {
  isOpen: boolean;
  toggleModal: () => void;
  updateId: string;
  goalId: string;
}) {
  const [remove] = useDeleteGoalProgressUpdate();
  const navigate = useNavigate();
  const paths = usePaths();

  const form = Forms.useForm({
    fields: {},
    cancel: toggleModal,
    submit: async () => {
      await remove({ id: updateId });
      showSuccessToast("Draft discarded", "The draft has been discarded.");
      navigate(paths.goalPath(goalId, { tab: "check-ins" }));
    },
  });

  return (
    <Modal isOpen={isOpen} onClose={toggleModal}>
      <Forms.Form form={form}>
        <p>Точно удалить черновик?</p>
        <Forms.Submit saveText="Отменить черновик" cancelText="Cancel" />
      </Forms.Form>
    </Modal>
  );
}
